import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EndpointService } from '../../../../../../@shared/endpoints.service';
import { MembershipResponse } from '../../../../../../@shared/models/response.module';
import { ToastService } from '../../../../../../@core/services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-member-modal',
  standalone: false,
  templateUrl: './edit-member-modal.html',
  styleUrl: './edit-member-modal.css'
})
export class EditMemberModal implements OnInit {
  @Input() membership: MembershipResponse;

  // Editable fields
  status: string = 'active';
  expiresAt: string = '';
  paymentStatus: string = 'paid';
  paymentMethod: string = 'manual';
  paymentNote: string = '';

  // For manual members
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  phone: string = '';

  isSubmitting: boolean = false;
  errorMessage: string = '';

  constructor(
    public activeModal: NgbActiveModal,
    private endpointService: EndpointService,
    private toastService: ToastService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    // Initialize form with current membership data
    this.status = this.membership.status || 'active';
    this.expiresAt = this.membership.expires_at ?
      new Date(this.membership.expires_at).toISOString().split('T')[0] : '';
    this.paymentStatus = this.membership.payment_status || 'paid';
    this.paymentMethod = this.membership.payment_method || 'manual';
    this.paymentNote = this.membership.payment_note || '';

    // For manual members
    if (this.membership.owner_type === 'manual') {
      this.firstName = this.membership.member_first_name || '';
      this.lastName = this.membership.member_last_name || '';
      this.email = this.membership.member_email || '';
      this.phone = this.membership.member_phone || '';
    }
  }

  get isManualMember(): boolean {
    return this.membership.owner_type === 'manual';
  }

  getMemberName(): string {
    if (this.membership.owner_type === 'manual') {
      return `${this.membership.member_first_name || ''} ${this.membership.member_last_name || ''}`.trim();
    }
    if (this.membership.owner_user) {
      return this.membership.owner_user.full_name ||
        `${this.membership.owner_user.first_name || ''} ${this.membership.owner_user.last_name || ''}`.trim();
    }
    if (this.membership.family?.members) {
      const owner = this.membership.family.members.find(m => m.role === 'owner');
      if (owner?.user) {
        return owner.user.full_name ||
          `${owner.user.first_name || ''} ${owner.user.last_name || ''}`.trim();
      }
    }
    return `Member #${this.membership.membership_id}`;
  }

  submit() {
    this.isSubmitting = true;
    this.errorMessage = '';

    const payload: any = {
      membership_id: this.membership.membership_id,
      status: this.status,
      expires_at: this.expiresAt || null,
      payment_status: this.paymentStatus,
      payment_method: this.paymentMethod,
      payment_note: this.paymentNote || null
    };

    // Add manual member fields if applicable
    if (this.isManualMember) {
      payload.member_first_name = this.firstName.trim();
      payload.member_last_name = this.lastName.trim();
      payload.member_email = this.email.trim() || null;
      payload.member_phone = this.phone.trim() || null;
    }

    this.endpointService.aqh_mem_10(payload).subscribe({
      next: (response) => {
        this.isSubmitting = false;
        this.toastService.success(this.translateService.instant('companyProfile.membershipPlans.editMember.success'));
        this.activeModal.close(response.data);
      },
      error: (error) => {
        this.isSubmitting = false;
        this.errorMessage = error?.error?.reason ||
          this.translateService.instant('companyProfile.membershipPlans.editMember.error');
        this.toastService.error(this.errorMessage);
      }
    });
  }
}
